import { gql } from '@apollo/client'

export const EXPORT_RESOURCES_SOURCES_QUERY = gql`
  query ResourcesSourcesImpacts(
    $first: Int
    $after: String
    $where: ResourceSourceImpactsGraphQlFilterInput
    $order: [ResourceSourceImpactsGraphQlSortInput!]
  ) {
    resourcesSourcesImpacts(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        resourceName
        sourceName
        combinedName
        countryName
        countryISOCode
        regionIdentifier
        description
        processName
        comment
        carbon
        waterUsage
        eutrophication
        secondaryDataReferenceSourceType
        dataQualityReliabilityScore
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        referenceSourcingCountryISOCode
        referenceRegionIdentifier
        dataQualityComment
        lastPublishedDate
        researcherName
        researcherEmail
        isVerified
        verificationComments
        verifiedByName
        verifiedByEmail
        verifiedOn
        updated
        lastUpdatedName
        userId
        userEmail
        resourceSourceId
        countryId
        regionIdentifierId
        referenceQuantity
        companyId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
